// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-weight: 700;
  margin: 2px 0 !important;
  color: var(--link-color);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/responsible-gaming/player-protection/player-protection.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,wBAAA;EACA,wBAAA;AACJ","sourcesContent":["p{\n    font-weight: 700;\n    margin: 2px 0!important;\n    color: var(--link-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
